import { useState } from 'react'
import { useDispatch } from 'react-redux'
import * as routerActions from 'connected-react-router'
import cn from 'clsx'

// Components
import { Dropdown, Link, IconChevronDown, useMaxWidth } from '@tracklib/kit'

import styles from './navlinkdropdown.css'

type NavLinkDropdownProps = {
  isActiveLink: boolean
  activePath: string
  label: string
  url: string
  links: Array<{
    url: string
    text: string
  }>
  onLinkClick?: () => void
  defaultOpen?: boolean
}

const NavLinkDropdown = ({
  label,
  url,
  links,
  isActiveLink,
  activePath,
  onLinkClick,
  defaultOpen = false,
}: NavLinkDropdownProps): JSX.Element => {
  const dispatch = useDispatch()
  const isSmall = useMaxWidth()

  const [active, toggleActive] = useState(isSmall ? defaultOpen : false)
  return (
    <div onMouseEnter={() => !isSmall && toggleActive(true)} onMouseLeave={() => !isSmall && toggleActive(false)}>
      <Dropdown
        active={active}
        label={
          <span className={cn(isActiveLink && styles.isActiveLink)}>
            {label} <IconChevronDown />
          </span>
        }
        labelClassName={cn(styles.label, active && styles.labelActive)}
        listClassName={styles.list}
        onToggle={() => {
          toggleActive(!active)
          if (!isSmall) {
            return dispatch(routerActions.push(url))
          }
          return null
        }}
      >
        <span className={styles.blocker} />
        {links.map(link => {
          return (
            <Dropdown.Item key={link.url}>
              <Link
                className={cn(styles.link, activePath.startsWith(link.url) && styles.isActiveLink)}
                to={link.url}
                onClick={() => {
                  if (onLinkClick) {
                    onLinkClick()
                  }
                  return toggleActive(false)
                }}
              >
                {link.text}
              </Link>
            </Dropdown.Item>
          )
        })}
      </Dropdown>
    </div>
  )
}

export default NavLinkDropdown
